import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { ContactType } from '../hooks';
import { MultiSelections } from 'views/mutual/inputRadio';
import { Caption } from 'views/mutual/caption';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { TextareaTemplate } from 'views/templates/module/textareaTemplate';
import { FormikProps } from 'formik';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { CheckInput } from 'views/templates/module/checkInput';
import React, { useState } from 'react';

export type ContactDetailsProps = {
  formik: FormikProps<ContactType>;
  contactProps: any;
};

export const ContactDetails = (props : ContactDetailsProps) => {
  const [checked, setChecked] = useState<boolean>(false);
  return (
    <form onSubmit={props.formik.handleSubmit} className="contactTemplate_input_check">
      <Caption label="お問い合わせ内容" />
      <TextareaTemplate {...props.contactProps.contactDetailsProps} placeholder="お問い合わせ内容をご記入ください"/>

      <div className="contactProcedure">
      <div className="contactProcedure_wrapper">
      <Description
        labelSize={labelSize.medium}
        label={`ご提供いただいた個人情報はお問い合わせに対応するために利用いたします。` }/>
      <Description
        labelSize={labelSize.medium}
        label={
          <>
          お問い合わせにあたっての個人情報の取り扱いについては、<a href={process.env.REACT_APP_FPG_INQUIRY_PRIVACY_POLICY_URL ?? ''} style={{ color: '#4f79e7' }} target="_blank" rel="noopener noreferrer">こちら</a>をご覧ください。
          </>
          }/>
        <br/>
      <Description
        labelSize={labelSize.medium}
        label={`当社個人情報の取り扱いに同意いただける場合は「同意します」にチェックを付け、「確認画面へ」ボタンをクリックしてください。`}/>      
      </div>
    </div>
      <div className="contactTemplate">
      <CheckInput
                name="fpg_inquiry_privacy_policy"
                label={'個人情報の取り扱いに同意します'}
                setChecked={() => setChecked(!checked)}
                checked = {checked}
              />
        <Button
          type={ButtonType.Submit}
          label={'確認画面へ'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          disable={!checked}
        />
      </div>
    </form>    
  );
};
